export default __webpack_public_path__ + "static/media/homevilla3.cd2e2e3d.jpg";